module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/advanced_tip-c355ab6e.png";